<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.unitId === undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.unitId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <FilterGroup :title="$t('servicesystem.common_objects.customer.ownership')"
              :applied-filters="[customerfilter]">
              <CustomerSelect v-model="customerfilter" clearable multiple externaledit>
              </CustomerSelect>
            </FilterGroup>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getUnitListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="100" :open-function="openItem"
          :dialogItem="editItem" :dialog-trigger="dialogtrigger" :dialog-method-config="dialogMethodConfig" :pk="pk"
          @Added="item => openItem(item)">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)" />
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <UnitEditContent :key="trigger" :item="item" :editMode="true" :handleFocus="() => { }">
            </UnitEditContent>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/UnitListItem.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import UnitEditContent from "./UnitEditContent.vue";
import FilterGroup from "@/components/FilterGroup.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";

export default {
  name: "AdminUnitList",
  props: {},
  components: {
    ListPane,
    FilterPane,
    Layout,
    ListItem,
    DefaultLifeCycleFilterGroup,
    UnitEditContent,
    CustomerSelect,
    FilterGroup,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "UL-",
      dialogtrigger: 1,
      editItem: {},
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createUnit',
        },
      }
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "UnitList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewUnit', params: { unitId: item.Id }, query })
    },

    setEditItem(item) {
      this.editItem = Object.assign({}, item);
      this.dialogtrigger++;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          CustomerIdList: this.customerfilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    customerfilter: {
      get() { return this.getQueryParam("filter-customer", []); },
      set(update) { this.setQueryParam("filter-customer", update); },
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>